export enum MeterAssetType {
  SingleMeterZ1 = "ZBHV_Z1",
  MultiMeterZ2 = "ZBHV_Z2",
  MultiMeterZ3 = "ZBHV_Z3",
  AutogasA1 = "ZBHV_A1",
}
